// Test de AFINIDAD — quién te acompaña.
//
// Los pesos son las claves de los cinco mentores del backend (`app/domain/mentores.py`):
// A1 Hipatia · Filosofía, A2 Max · Literatura, A3 Ariadna · Psicología, A4 Ulises ·
// Cultura Clásica, A5 Lira · Música.
//
// LAS PREGUNTAS SON DE TRATO, NO DE MATERIA, y esa es toda la idea: aquí no se elige qué
// se estudia -para eso está el test de ruta- sino cómo prefieres que te hablen cuando te
// equivocas, cuando aciertas y cuando te atascas. Por eso un alumno puede salir con Lira
// sin que le interese la música: lo que ha elegido es el tono.
//
// No sale de aquí ninguna etiqueta sobre el alumno. Sale una preferencia, y las
// preferencias se cambian desde el perfil sin repetir nada.
export const PREGUNTAS_AFINIDAD = [
  {
    id: "a1",
    prompt: "Empecemos por lo importante:",
    question: "Acabas de entregar algo que te ha costado. ¿Cómo prefieres que te respondan?",
    options: [
      { id: "a", label: "«Correcto. Sigue.» Sin adornos.", weights: { A1: 3, A2: 1 } },
      { id: "b", label: "«Perdona. Necesito un momento. Eso ha sido ARTE.»", weights: { A4: 3, A5: 1 } },
      { id: "c", label: "«Eso que acabas de hacer se llama pensar.»", weights: { A3: 3, A1: 1 } },
      { id: "d", label: "Que me señalen la frase exacta que ha funcionado", weights: { A2: 3, A5: 1 } },
    ],
  },
  {
    id: "a2",
    prompt: "Y cuando sale mal:",
    question: "Te has equivocado en algo que creías saber. ¿Qué te ayuda más?",
    options: [
      { id: "a", label: "«No. Otra vez, y esta vez piénsalo.»", weights: { A1: 3, A4: 1 } },
      { id: "b", label: "«No pasa nada. En serio. Otra vez.»", weights: { A3: 3, A2: 1 } },
      { id: "c", label: "«Ay. Ay, no. Eso me ha dolido físicamente.»", weights: { A4: 3, A5: 1 } },
      { id: "d", label: "Que me enseñen dónde se torció, paso a paso", weights: { A5: 3, A1: 1 } },
    ],
  },
  {
    id: "a3",
    prompt: "Sobre el ritmo:",
    question: "¿Cómo prefieres que empiece una explicación?",
    options: [
      { id: "a", label: "Con una pregunta que me descoloque", weights: { A1: 3, A3: 1 } },
      { id: "b", label: "Con una historia", weights: { A2: 3, A4: 1 } },
      { id: "c", label: "Con un ejemplo de algo que ya me pasa", weights: { A3: 3, A5: 1 } },
      { id: "d", label: "Con algo antiguo que resulta que sigue igual", weights: { A4: 3, A2: 1 } },
    ],
  },
  {
    id: "a4",
    prompt: "Una de humor:",
    question: "¿Qué clase de gracia te cae bien a las once de la noche?",
    options: [
      { id: "a", label: "La seca: una frase corta y a otra cosa", weights: { A1: 3, A2: 1 } },
      { id: "b", label: "La exagerada: que todo sea una tragedia griega", weights: { A4: 3, A5: 1 } },
      { id: "c", label: "La cómplice: que se ría conmigo, no de mí", weights: { A3: 3, A2: 1 } },
      { id: "d", label: "La rara: la que no esperas", weights: { A5: 3, A4: 1 } },
    ],
  },
  {
    id: "a5",
    prompt: "Cuando te atascas:",
    question: "Llevas veinte minutos sin avanzar. ¿Qué prefieres?",
    options: [
      { id: "a", label: "Que me devuelvan la pregunta mejor formulada", weights: { A1: 3, A3: 1 } },
      { id: "b", label: "Que me lo cuenten con otras palabras", weights: { A2: 3, A3: 1 } },
      { id: "c", label: "Que me pregunten primero qué me está pasando", weights: { A3: 3, A4: 1 } },
      { id: "d", label: "Que me pongan un ejemplo y lo desmonten conmigo", weights: { A5: 3, A1: 1 } },
    ],
  },
  {
    id: "a6",
    prompt: "Sobre la exigencia:",
    question: "¿Cuánto quieres que te aprieten?",
    options: [
      { id: "a", label: "Mucho. Si me lo ponen fácil, me aburro.", weights: { A1: 3, A4: 1 } },
      { id: "b", label: "Lo justo: que note que se puede más, sin agobio", weights: { A2: 3, A5: 1 } },
      { id: "c", label: "Poco al principio y más según voy pudiendo", weights: { A3: 3, A2: 1 } },
      { id: "d", label: "Depende del día, y quiero que se note que lo saben", weights: { A5: 3, A3: 1 } },
    ],
  },
  {
    id: "a7",
    prompt: "Casi está:",
    question: "¿Qué te da más ganas de volver mañana?",
    options: [
      { id: "a", label: "Haber entendido algo que ayer no entendía", weights: { A1: 3, A5: 1 } },
      { id: "b", label: "Haber escrito algo que me ha gustado leer", weights: { A2: 3, A4: 1 } },
      { id: "c", label: "Haber terminado sin haberme agobiado", weights: { A3: 3, A2: 1 } },
      { id: "d", label: "Haber descubierto una historia que no conocía", weights: { A4: 3, A3: 1 } },
    ],
  },
  // LAS DOS QUE LLEGARON DEL TEST DE RUTA el 18 de octubre de 2026. Estaban entre sus
  // veintidós y eran de TRATO, no de materia: preguntaban por cómo quieres que te hablen,
  // que es lo único que este test decide. Allí sólo repartían puntos entre competencias;
  // aquí eligen mentor, que es para lo que servían.
  {
    id: "a9",
    prompt: "Sobre quién enseña:",
    question: "Un buen profesor es alguien que…",
    options: [
      { id: "a", label: "Te desmonta lo que creías saber", weights: { A1: 3, A4: 1 } },
      { id: "b", label: "Te escucha antes de responder", weights: { A3: 3, A2: 1 } },
      { id: "c", label: "Te ofrece nuevas obras y autores", weights: { A2: 3, A4: 1 } },
      { id: "d", label: "Te enseña a mirar diferente", weights: { A5: 3, A1: 1 } },
    ],
  },
  {
    id: "a10",
    prompt: "Y lo que más pesa:",
    question: "¿Qué es lo que más valoras en un profesor?",
    options: [
      { id: "a", label: "Que te haga reflexionar sobre tu vida", weights: { A3: 2, A1: 2 } },
      { id: "b", label: "Que se acuerde de por dónde ibas", weights: { A3: 3, A5: 1 } },
      { id: "c", label: "Que te recomiende lo que aún no sabes que quieres leer", weights: { A2: 3, A4: 1 } },
      { id: "d", label: "Que se adapte al día que llevas", weights: { A5: 3, A3: 1 } },
    ],
  },
  {
    id: "a8",
    prompt: "La última:",
    question: "Si tu mentor solo pudiera decirte una frase al día, ¿cuál eliges?",
    options: [
      { id: "a", label: "«Ese argumento se cae solo. Ni lo he tenido que empujar.»", weights: { A1: 3, A2: 1 } },
      { id: "b", label: "«Repite eso otra vez que lo quiero enmarcar.»", weights: { A4: 3, A5: 1 } },
      { id: "c", label: "«Ese fallo es de los buenos: de los que enseñan algo.»", weights: { A3: 3, A1: 1 } },
      { id: "d", label: "«Escucha otra vez. Ahora fíjate en lo que no suena.»", weights: { A5: 3, A2: 1 } },
    ],
  },
];
